import { useTranslation } from 'react-i18next'
import { Typography } from 'mobily-ui-library/lib'

import AppleLogo from '../../../assets/AppleCareLogo.svg'
import ACSupport from '../../../assets/ACSupport.svg'
import ACBattery from '../../../assets/ACBattery.svg'
import ACDamage from '../../../assets/ACDamage.svg'
import ACRepair from '../../../assets/ACRepair.svg'

import './AppleCare.scss'

interface AppleCareProps {
  rtl: boolean
}

function AppleCare({ rtl }: AppleCareProps) {
  const { t } = useTranslation()

  return (
    <>
      <div id='appleCare-card' className={`appleCare-card ${rtl ? 'pl-3' : 'pr-3'}`}>
        <div className='card_content'>
          <div className='card_text_section'>
            <img className="apple__logo" src={AppleLogo} alt="alt" width={62} height={24} />
            <div className='appleCare-card-textContainer'>
              <Typography rtl={rtl} className='device_tradeIn_title'>{t('AppleCare_plus')}</Typography>
              <Typography rtl={rtl} className='device_tradeIn_subTitle' >{t('AppleCareDevice__subtitle')}</Typography>
            </div>
          </div>
          <div className='apple_new_container'>
            <Typography className='apple_new_text'>{t('new')}</Typography>
          </div>
        </div>
      </div>
    </>

  )
}


export default AppleCare
